(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-custom-template"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const video = document.getElementById('product-video');
  const controlBtn = document.getElementById('product-video-control-btn');
  
  if (!video || !controlBtn) return;
  
  const playIcon = controlBtn.querySelector('.video-play-icon');
  const pauseIcon = controlBtn.querySelector('.video-pause-icon');
  
  let isPlaying = !video.paused; // Check actual video state
  
  function updateButtonState() {
    if (isPlaying) {
      playIcon.style.display = 'none';
      pauseIcon.style.display = 'block';
      controlBtn.setAttribute('aria-label', 'Pause video');
    } else {
      playIcon.style.display = 'block';
      pauseIcon.style.display = 'none';
      controlBtn.setAttribute('aria-label', 'Play video');
    }
  }
  
  function toggleVideo() {
    try {
      if (isPlaying) {
        video.pause();
      } else {
        video.play();
      }
    } catch (error) {
      console.log('Product video control error:', error);
    }
  }
  
  // Button click handler
  controlBtn.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    toggleVideo();
  });
  
  // Keyboard support (Enter and Space)
  controlBtn.addEventListener('keydown', function(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      e.stopPropagation();
      toggleVideo();
    }
  });
  
  // Video event listeners to sync button state
  video.addEventListener('play', function() {
    isPlaying = true;
    updateButtonState();
  });
  
  video.addEventListener('pause', function() {
    isPlaying = false;
    updateButtonState();
  });
  
  video.addEventListener('loadedmetadata', function() {
    isPlaying = !video.paused;
    updateButtonState();
  });
  
  // Initialize button state
  setTimeout(updateButtonState, 100);
});

  } catch(e) { console.error(e); }
})();
})();
